const state = {
  data: [],
  lastDateUpdated: 0
}

export default state